/**
 * @generated SignedSource<<a6c012d87f0ead140f61f8a4c1655d3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contributionsCount"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contributionsCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contributionsFilters"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contributionsSort"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconClass",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryColor",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryContrastColor",
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "contributionsCursor"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "contributionsFilters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "contributionsCount"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "contributionsSort"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reactionsCount",
  "storageKey": null
},
v10 = [
  (v3/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContributionsDatavizGraphThemePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContributionsDatavizGraphTheme_theme"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContributionsDatavizGraphThemePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipativeModule",
                "kind": "LinkedField",
                "name": "participativeModule",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "visualization",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "enableListViewOnFirstPage",
                            "storageKey": null
                          }
                        ],
                        "type": "ContributionsDataviz",
                        "abstractKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ParticipativeModuleAuthorizations",
                    "kind": "LinkedField",
                    "name": "authorizations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bookmarksCreationAuthorized",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "themes",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Theme",
                        "kind": "LinkedField",
                        "name": "children",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "ContributionConnection",
                "kind": "LinkedField",
                "name": "contributions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContributionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Contribution",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isBookmarked",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isMine",
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Theme",
                            "kind": "LinkedField",
                            "name": "themes",
                            "plural": true,
                            "selections": (v10/*: any*/),
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "filters": [
                  "filters",
                  "sort"
                ],
                "handle": "connection",
                "key": "ContributionsDatavizGraphTheme_contributions",
                "kind": "LinkedHandle",
                "name": "contributions"
              },
              (v11/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "children",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v11/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "parent",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Theme",
                        "kind": "LinkedField",
                        "name": "parent",
                        "plural": false,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contributionsCount",
                "storageKey": null
              },
              (v9/*: any*/),
              (v4/*: any*/)
            ],
            "type": "Theme",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "134e62a96fcf78a081e4af710e15f98e",
    "id": null,
    "metadata": {},
    "name": "ContributionsDatavizGraphThemePaginationQuery",
    "operationKind": "query",
    "text": "query ContributionsDatavizGraphThemePaginationQuery(\n  $contributionsCount: Int\n  $contributionsCursor: String\n  $contributionsFilters: ContributionsListFiltersInput\n  $contributionsSort: ContributionsSortInput\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ContributionsDatavizGraphTheme_theme\n    id\n  }\n}\n\nfragment BookmarkedFilter_participativeModule on ParticipativeModule {\n  authorizations {\n    bookmarksCreationAuthorized\n  }\n}\n\nfragment ContributionsDatavizContributionTooltip_theme on Theme {\n  name\n  iconClass\n  primaryColor\n  primaryContrastColor\n  parent {\n    name\n    id\n  }\n}\n\nfragment ContributionsDatavizFilters_participativeModule on ParticipativeModule {\n  ...ContributionsDatavizViewerFilters_participativeModule\n}\n\nfragment ContributionsDatavizGraphThemeAnimation_theme on Theme {\n  slug\n  primaryColor\n  primaryContrastColor\n  participativeModule {\n    id\n    slug\n  }\n  ...ContributionsDatavizContributionTooltip_theme\n}\n\nfragment ContributionsDatavizGraphTheme_theme on Theme {\n  participativeModule {\n    ...ContributionsDatavizMainContainerHeader_participativeModule\n    id\n    ...ContributionsDatavizViewModeSwitch_participativeModule\n  }\n  contributions(first: $contributionsCount, after: $contributionsCursor, filters: $contributionsFilters, sort: $contributionsSort) {\n    edges {\n      node {\n        id\n        slug\n        title\n        isBookmarked\n        isMine\n        reactionsCount\n        themes {\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...ContributionsDatavizThemeLayout_theme\n  ...ContributionsDatavizGraphThemeAnimation_theme\n  ...ContributionsDatavizMainContainerHeader_theme\n  id\n}\n\nfragment ContributionsDatavizMainContainerHeader_participativeModule on ParticipativeModule {\n  ...ContributionsDatavizViewModeSwitch_participativeModule\n}\n\nfragment ContributionsDatavizMainContainerHeader_theme on Theme {\n  ...ContributionsDatavizViewModeSwitch_theme\n}\n\nfragment ContributionsDatavizSearchFiltersThemes_themes on Theme {\n  id\n  name\n  primaryColor\n  primaryContrastColor\n  iconClass\n  parent {\n    id\n    parent {\n      id\n    }\n  }\n}\n\nfragment ContributionsDatavizTabs_participativeModule on ParticipativeModule {\n  slug\n  visualization {\n    __typename\n    ... on ContributionsDataviz {\n      enableListViewOnFirstPage\n    }\n    id\n  }\n}\n\nfragment ContributionsDatavizThemeLayout_theme on Theme {\n  participativeModule {\n    slug\n    ...ContributionsDatavizTabs_participativeModule\n    id\n  }\n  ...ContributionsDatavizThemeViewSidebar_theme\n  ...ContributionsDatavizViewModeSwitch_theme\n}\n\nfragment ContributionsDatavizThemeMeasures_theme on Theme {\n  contributionsCount\n  reactionsCount\n}\n\nfragment ContributionsDatavizThemeViewSidebar_theme on Theme {\n  name\n  iconClass\n  primaryColor\n  primaryContrastColor\n  parent {\n    name\n    id\n  }\n  children {\n    ...ContributionsDatavizSearchFiltersThemes_themes\n    id\n  }\n  participativeModule {\n    slug\n    ...ContributionsDatavizFilters_participativeModule\n    id\n  }\n  ...ContributionsDatavizThemeMeasures_theme\n  ...ContributionsDatavizThemesCarousel_currentTheme\n}\n\nfragment ContributionsDatavizThemesCarousel_currentTheme on Theme {\n  id\n  participativeModule {\n    slug\n    themes {\n      id\n      slug\n      iconClass\n      primaryColor\n      primaryContrastColor\n      children {\n        id\n        slug\n        iconClass\n        primaryColor\n        primaryContrastColor\n      }\n    }\n    id\n  }\n}\n\nfragment ContributionsDatavizViewModeSwitch_participativeModule on ParticipativeModule {\n  slug\n}\n\nfragment ContributionsDatavizViewModeSwitch_theme on Theme {\n  slug\n}\n\nfragment ContributionsDatavizViewerFilters_participativeModule on ParticipativeModule {\n  ...BookmarkedFilter_participativeModule\n}\n"
  }
};
})();

node.hash = "2c12e6b744331728e05f0c9bcdcd772c";

module.exports = node;
